import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import QUERY_PRODUCTS from '../../../../graphql/query/product/products.query';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { mediaDir } from '../../../../appolloConfig';
import { ProductOnPanier } from '../../../../types/product/product';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GetProductsQuery } from '../../../../graphql/generated/graphql';
import { Modal } from '../../Modals/Modal';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';
import { IconButton } from '../../../atoms/Buttons/IconButton';
import useStyle from './updateCommande.style';
import { getProductDefFromQuery } from '../../../../helpers/transformApiResponse/product';

interface AddProductFieldsProps {
  handleChange: (
    e: { target: { name: string; value: ProductOnPanier } },
    type: 'client' | 'commandelines' | 'commande',
    i?: number
  ) => void;
}

const AddProductFields = ({ handleChange }: AddProductFieldsProps) => {
  const classes = useStyle();
  const [formatedProduct, setFormatedProduct] = useState<ProductOnPanier[]>(
    undefined
  );

  const [getProducts, { data, loading, error }] = useLazyQuery<
    GetProductsQuery
  >(QUERY_PRODUCTS, {
    variables: {
      offset: 0,
      limit: 100
    }
  });
  useEffect(() => {
    setFormatedProduct(
      data?.produits?.data?.map(produit => getProductDefFromQuery(produit))
    );
  }, [data]);

  const setProduct = (produit: ProductOnPanier) => {
    handleChange({ target: { name: 'add', value: produit } }, 'commandelines');
  };

  return (
    <Modal
      modalHead={'Ajouter un produit'}
      triggerButton={
        <ButtonWithText
          content={'Ajouter un produit'}
          onClick={getProducts}
          icon={'Plus'}
        />
      }
    >
      {loading && <LoadingContainer />}
      {error && <ErrorContainer />}
      <div>
        {formatedProduct &&
          formatedProduct.map(product => (
            <div className={classes.modalLineProduct}>
              <div className={classes.modalLineInfo}>
                <img
                  src={mediaDir + product?.media[0]?.url}
                  className={classes.modalLineImg}
                  alt={product?.name}
                />
                <p>
                  {product.name} - {product.ttcPrice} €
                </p>
              </div>
              <IconButton onClick={() => setProduct(product)} icon={'Plus'} />
            </div>
          ))}
      </div>
    </Modal>
  );
};
export default AddProductFields;
